import { MenuItem as ReactMenuItem } from '@szhsin/react-menu';
import type { ReactNode, VoidFunctionComponent } from 'react';

import RouterLink from '../Link/RouterLink';

type Props = {
  to: string;
  children: ReactNode;
};

/**
 * A menu item that renders as a navigational anchor.
 *
 * Wraps a RouterLink in szhsin's MenuItem and applies the
 * `szh-menu__item--anchor` class the library expects on anchor children so
 * the link inherits the row's hover/colour styling instead of falling back
 * to default anchor styles.
 */
export const MenuItemLink: VoidFunctionComponent<Props> = ({ to, children }) => (
  <ReactMenuItem>
    <RouterLink className="szh-menu__item--anchor" to={to}>
      {children}
    </RouterLink>
  </ReactMenuItem>
);
